<script setup lang="ts">
  import {
    Table,
    TableBody,
    TableCell,
    TableEmpty,
    TableHead,
    TableHeader,
    TableRow
  } from '@gat-ship/vue-components'
  import { useFormatting } from '@gat-ship/utils'
  import { useSupportSessionContext } from '../../composables/useSupportSession'
  import SupportSessionCellStatus from './SupportSessionCellStatus.vue'
  import SupportSessionCellActions from './SupportSessionCellActions.vue'

  const supportSessionService = useSupportSessionContext()!
  const { formatDateRange } = useFormatting()

  const sortedData = supportSessionService.sortedMySessions
</script>

<template>
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead>Granted From - To</TableHead>
        <TableHead>Status</TableHead>
        <TableHead class="w-10">
          <span class="sr-only">Actions</span>
        </TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableEmpty v-if="sortedData.length === 0" :colspan="3">
        No support sessions.
      </TableEmpty>
      <TableRow v-for="session in sortedData" :key="session.sessionId">
        <TableCell>
          {{ formatDateRange(session.grantedFrom, session.grantedTo) }}
        </TableCell>
        <TableCell>
          <SupportSessionCellStatus :granted-to="session.grantedTo" />
        </TableCell>
        <TableCell class="text-right">
          <SupportSessionCellActions :session="session" />
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</template>
